import { country } from "@features/country/data";
import {
  completedUrlsPages,
  getCountryCodeFromUrl,
} from "@features/shared/presentation";
import { navigateTo, NAVIGATING } from "@taager/react-router";
import { type GenericObject } from "@taager/reinforcements";

export function hardNavigate(url: string, params?: GenericObject) {
  const fullUrl = new URL(window.location.href);

  fullUrl.pathname = `/${country.shortCode || getCountryCodeFromUrl()}${url}`;

  if (params) {
    fullUrl.search = new URLSearchParams(params).toString();
  }

  window.location.href = fullUrl.toString();

  // this return is used to stop rendering the page component as this function may be middleware
  return NAVIGATING;
}

// This function checks if the given path matches any route in completedUrlsPages.
// It supports both static and dynamic routes (e.g., /products/:id).
// For dynamic routes, it converts segments like :id to a regex wildcard ([^/]+),
// so /products/123 will match /products/:id.
// Example:
//   completedUrlsPages = ["/products", "/products/:id"]
//   path = "/products/123"
//   The function will return true because "/products/123" matches the dynamic route pattern.
export function isCompletedUrl(path: string): boolean {
  return completedUrlsPages.some(route => {
    const pattern = "^" + route.replace(/:[^/]+/g, "[^/]+") + "$";
    return new RegExp(pattern).test(path);
  });
}

export function navigate(url: string, params?: GenericObject) {
  const route = url.split("?")[0];

  if (isCompletedUrl(route)) {
    return navigateTo(url);
  }

  return hardNavigate(url, params);
}
